import { render, staticRenderFns } from "./film.vue?vue&type=template&id=760bc079&"
import script from "./film.vue?vue&type=script&lang=js&"
export * from "./film.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports